export const supportedLocales = [
	'af',
	'ar',
	'be',
	'bg',
	'bn',
	'ca',
	'cs',
	'cy',
	'da',
	'de',
	'el',
	'en-AU',
	'en-CA',
	'en-GB',
	'en-US',
	'eo',
	'es',
	'et',
	'fa-IR',
	'fi',
	'fr',
	'fr-CA',
	'gl',
	'gu',
	'he',
	'hi',
	'hr',
	'hu',
	'hy',
	'id',
	'is',
	'it',
	'ja',
	'ka',
	'kk',
	'ko',
	'lt',
	'lv',
	'nb',
	'nl',
	'nn',
	'pl',
	'pt',
	'pt-BR',
	'ro',
	'ru',
	'sk',
	'sl',
	'sr',
	'sr-Latn',
	'sv',
	'ta',
	'te',
	'th',
	'tr',
	'ug',
	'uk',
	'vi',
	'zh_CN',
	'zh_TW',
];
